@if (!isLoading) {
  <div class="analise" fxLayout="column" fxLayoutGap="22px">
    <table aria-describedby="grafico vocacao x potencial">
      <tr>
        <th id=""></th>
        @for (potential of analysis.potenciais; track potential) {
          <th id="">{{potential.descricao}}</th>
        }
      </tr>
      @for (vocation of vocations; track vocation; let sectorIndex = $index) {
        <tr>
          <td>{{vocation.descricao}}</td>
          @for (cruzamento of vocation.cruzamento; track cruzamento; let vocpotIndex = $index) {
            <td>
              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
                <span class="material-icons check-orange pointer"
                  (click)="null"
                  [ngClass]="{'checked': cruzamento.alavancaInovacaoLocalidade, 'pointer': false}">
                  check_circle
                </span>
                <span class="material-icons check-green"
                  (click)="null"
                  [ngClass]="{'checked': cruzamento.alavancaInovacaoConhecimento, 'pointer': false}">
                  check_circle
                </span>
              </div>
            </td>
          }
        </tr>
      }
    </table>
    <div fxLayout="row">
      <span class="legend"> Análise da sinergia Vocação X Potencial </span>
    </div>
  </div>
}

@if (isLoading) {
  <div style="height: 150px;" fxLayoutAlign="center center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}